import React, { Component } from 'react';
import AuthStore from "../../stores/Auth";
import {
  useLocation,
  useNavigate,
  useParams,
  NavigateFunction,
  Params,
} from "react-router-dom";

interface RouterProps {
  location: ReturnType<typeof useLocation>;
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
}

export interface PropsWithRouter {
  router: RouterProps;
}

export function withRouter<T extends PropsWithRouter>(
  Component: React.ComponentType<T>
): React.FC<Omit<T, keyof PropsWithRouter>> {
  return function ComponentWithRouterProp(props: Omit<T, keyof PropsWithRouter>) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const role = AuthStore.getRole();
    const router: RouterProps = { location, navigate, params };

    return <Component {...(props as T)} router={router} role = {role}/>;
  };
}